module.exports = __webpack_public_path__ + "media/harp-sound.4f8b531c.mp3";